import Swipe from './swipe.vue';
import SwipeItem from './swipe-item.vue';

export { Swipe, SwipeItem };



// WEBPACK FOOTER //
// libs/components/detail/swipe/index.js